var map = {
	"./Mango_Shaved_Ice.png": 60,
	"./Minced_Pork_Rice.png": 61,
	"./Night_Market.png": 62,
	"./Rice_cooker.png": 63,
	"./Taiwan_Beer.png": 64,
	"./Xiaolongbao.png": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;